import React, { PureComponent } from 'react';

import {
    View,
    Image,
    StyleSheet,
} from 'react-native'
import {
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib'

import { pt, px } from '../../common/utils';

export default class QRCode extends PureComponent {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        codeInfo: {
            ticketPwd: '11111111111',
            ticketCode: '11111111111',
            qrCodeUrl: 'aaa'
        }
    }
    render() {
        let { codeInfo, islist } = this.props;
        return (
            <View style={st.QRcode}>
                {!islist&&<View style={st.line}></View>}
                <View style={[st.yzm,islist&&{margin: pt(0),marginBottom: pt(15)}]}>
                {codeInfo.ticketCode&&<JDText stylt={st.txt_m}>序列号 {(codeInfo.ticketCode).replace(/(\d{4})/g,'$1 ')}</JDText>}
                    {codeInfo.ticketPwd&&<JDText stylt={st.txt_m}>验证码 {(codeInfo.ticketPwd).replace(/(\d{4})/g,'$1 ')}</JDText>}
                </View>
                <View style={st.img_view}>
                    <JDImage style={st.y_img} source={{uri: codeInfo.qrCodeUrl}}></JDImage>
                </View>
            </View>
        )
    }
}

const st = StyleSheet.create({
    line: {
        borderStyle: 'dashed',
        borderColor:'#D3D3D3',
        height: 0,
        borderWidth:px(1),
        borderRadius:3,
    },
    yzm: {
        backgroundColor: '#F5F7F8',
        margin: pt(15),
        borderRadius: pt(2),
        paddingVertical: pt(8),
        paddingLeft: pt(10),
        justifyContent: 'center',
        alignItems: 'center'
    },
    txt_m: {
        textAlign: 'center',
    },
    img_view: {
        paddingBottom: pt(23),
        justifyContent: 'center',
        alignItems: 'center',
    },
    y_img: {
        height: pt(123),
        width: pt(123),
        padding: pt(5),
        borderWidth: px(1),
        borderColor:'#D3D3D3',
    },
})